import axios from '@/api/axios';

import { forceFileDownload } from './computers/index';

export async function getPdf(url, filename, title, selectedComputers, selectedLogs) {
  try {
    const response = await axios.post(
      '/pdf',
      { url, title, selectedComputers, selectedLogs },
      { responseType: 'blob' },
    );
    forceFileDownload(response, `${filename}.pdf`);
    return response;
  } catch (error) {
    console.error(error);

    throw error;
  }
}
